/* Native Shopify form submission with the selected cord or bundle variant. */
if (!customElements.get('kalzen-link-buy-box')) {
  customElements.define('kalzen-link-buy-box', class extends HTMLElement {
    connectedCallback() {
      if (this.linkReady) return;
      this.linkReady = true;
      this.variantInput = this.querySelector('[data-link-id]');
      this.variantSelect = this.querySelector('[data-link-variant]');
      this.addButton = this.querySelector('[data-link-add]');
      this.addLabel = this.querySelector('[data-link-add-label]');
      this.price = this.querySelector('[data-link-price]');
      this.compare = this.querySelector('[data-link-compare]');
      this.status = this.querySelector('[data-link-status]');
      this.quantity = this.querySelector('[data-quantity-input]');
      this.minus = this.querySelector('[data-quantity-minus]');
      this.plus = this.querySelector('[data-quantity-plus]');
      this.variants = JSON.parse(this.querySelector('[data-link-variants]')?.textContent || '[]');
      this.offers = Array.from(this.querySelectorAll('[data-link-offer]'));
      this.mainVariantId = this.variantSelect?.value || this.variantInput.value;
      this.offers.forEach(offer => {
        offer.disabled = false;
        offer.addEventListener('change', () => this.selectOffer(offer));
      });
      this.variantSelect?.addEventListener('change', () => {
        this.mainVariantId = this.variantSelect.value;
        const main = this.offers.find(offer => offer.dataset.linkOffer === 'main');
        main.checked = true;
        this.selectOffer(main);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', this.mainVariantId);
        window.history.replaceState({}, '', url);
      });
      this.minus.addEventListener('click', () => {
        this.normalizeQuantity();
        this.quantity.stepDown();
        this.normalizeQuantity();
      });
      this.plus.addEventListener('click', () => {
        this.normalizeQuantity();
        this.quantity.stepUp();
        this.normalizeQuantity();
      });
      this.quantity.addEventListener('change', () => this.normalizeQuantity());
      this.querySelector('form').addEventListener('submit', () => this.normalizeQuantity(), true);
      this.selectOffer(this.offers.find(offer => offer.checked) || this.offers[0]);
    }

    normalizeQuantity() {
      const min = Number(this.quantity.min) || 1;
      const step = Number(this.quantity.step) || 1;
      const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
      let count = Number(this.quantity.value);
      if (!Number.isFinite(count) || count < min) count = min;
      count = min + Math.floor((Math.min(count, max) - min) / step) * step;
      this.quantity.value = Math.max(min, count);
      this.minus.disabled = Number(this.quantity.value) <= min;
      this.plus.disabled = Number(this.quantity.value) + step > max;
    }

    selectOffer(offer) {
      if (!offer) return;
      const isBundle = offer.dataset.linkOffer === 'bundle';
      const mainVariant = this.variants.find(item => String(item.id) === String(this.mainVariantId));
      const selectedId = isBundle ? offer.dataset.variantId : this.mainVariantId;
      const available = isBundle ? offer.dataset.available === 'true' : Boolean(mainVariant?.available);
      this.variantInput.value = selectedId || '';
      this.variantInput.disabled = !isBundle && Boolean(this.variantSelect);
      if (this.variantSelect) this.variantSelect.disabled = isBundle;
      if (mainVariant) {
        this.price.textContent = mainVariant.price;
        this.compare.textContent = mainVariant.compare_price || '';
        this.compare.hidden = !mainVariant.on_sale;
      }
      const quantityRule = isBundle
        ? { min: offer.dataset.quantityMin, increment: offer.dataset.quantityStep, max: offer.dataset.quantityMax }
        : mainVariant?.quantity_rule;
      this.quantity.min = quantityRule?.min || 1;
      this.quantity.step = quantityRule?.increment || 1;
      if (quantityRule?.max) this.quantity.max = quantityRule.max;
      else this.quantity.removeAttribute('max');
      this.normalizeQuantity();
      this.addButton.disabled = !available || !selectedId;
      this.addLabel.textContent = available && selectedId ? 'ADD TO CART' : 'SOLD OUT';
      this.status.textContent = `${offer.value} selected${available ? '.' : '. Currently sold out.'}`;
      this.offers.forEach(item => item.closest('.kzl-offer')?.classList.toggle('is-selected', item === offer));
    }
  });
}
